// @flow
import React, { Component } from "react";
import _ from "lodash";
import I18n from "../../../i18n/I18n";
import Icon from "../../common/Icon";
import Loader from "../../common/loader/Loader";
import EmptyResults from "../../common/emptyResults/EmptyResults";
import SearchProductBox from "../searchProductBox/SearchProductBox";
import styles from "./OfferSearch.scss";

type Props = {
  data: Object,
  searchProductsData: Function
};

type State = {
  query: string
};

class OfferSearch extends Component<Props, State> {
  constructor() {
    super();

    this.state = {
      query: ""
    };
  }

  textChange(e: Object, key: any) {
    var newState = {};

    newState[e.target.name] = e.target.value;
    this.props.searchProductsData(e.target.value);
    this.setState(newState);
  }

  render() {
    const data = this.props.data || "";
    const productList =
      data && data.hits && !_.isEmpty(data.hits) ? (
        data.hits.map((product, index) => (
          <div className={styles.searchBox} key={index}>
            <SearchProductBox product={product} />
          </div>
        ))
      ) : (
        <EmptyResults type="products" />
      );
    return (
      <div className={styles.searchFlexer}>
        <div className={styles.ctr}>
          {false && <div className={styles.categoryArea} />}
          <div className={styles.searchListArea}>
            <div className={styles.searchInputWrapper}>
              <div className={styles.searchIcon}>
                <Icon name="search" />
              </div>

              {I18n.getComponent(
                formattedValue => (
                  <input
                    type="search"
                    className={styles.searcInput}
                    name="query"
                    value={this.state.query}
                    placeholder={formattedValue}
                    onChange={e => this.textChange(e)}
                  />
                ),
                "offers-search.placeholder"
              )}
            </div>
            <div className={styles.relativer}>
              <div className={styles.searchResultWrapper}>
                {this.props.isSearchLoading ? (
                  <div>
                    <Loader />
                  </div>
                ) : (
                  productList
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default OfferSearch;



// WEBPACK FOOTER //
// ./src/components/products/offerSearch/OfferSearch.js